import React from 'react'
import RegistroActividad from './RegistrarActividad'
import ListarActividad from './ListarActividad'

const Actividad = () => {
  return (
    <div>
      <RegistroActividad/>
      <ListarActividad/>

    </div>
  )
}

export default Actividad
